/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ant-reset-private/blob/master/LICENSE
 */

export default {
  // Options.jsx
  items_per_page: '/ pÃ¡ginas',
  jump_to: 'VÃ¡ atÃ©',
  jump_to_confirm: 'confirme',
  page: '',

  // Pagination.jsx
  prev_page: 'PÃ¡gina anterior',
  next_page: 'PrÃ³xima pÃ¡gina',
  prev_5: '5 pÃ¡ginas anteriores',
  next_5: '5 prÃ³ximas pÃ¡ginas',
  prev_3: '3 pÃ¡ginas anteriores',
  next_3: '3 prÃ³ximas pÃ¡ginas'
};
